module.exports = __webpack_public_path__ + "img/013.42b3fbf9.jpg";